// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__jwMTJ","placeholdersHeader":"styles_placeholdersHeader__IiNYv","editorStyle":"styles_editorStyle__3j5TE","placeholdersBox":"styles_placeholdersBox__1Y8TE"};